module.exports = __webpack_public_path__ + "media/27.d0e1c5a5.wav";